import Vue from "vue";
import CreativeLib from "../../components/creativeLib.vue";
export default Vue.extend({
    components: {
        CreativeLib: CreativeLib
    },
    data: function data() {
        return {};
    }
});
